
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";

import rules from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Edit",

  data: () => ({
    rules,
    model: {
      values: [] as Array<any>
    } as any,
    disableSave: true as boolean,
    fullLoaded: false as boolean,
    errorMessages: {
      values: [] as Array<any>
    } as { [value: string]: Array<string> },
    serviceTypes: [] as Array<any>
  }),

  watch: {
    model: {
      deep: true,
      handler() {
        if (this.fullLoaded) {
          this.disableSave = false;
        }
      }
    }
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const item = await API.services().getForEdit(Number(to.params.id));
      const serviceTypes = await API.serviceTypes().getList();

      next(vm => {
        vm.model = item;
        vm.serviceTypes = serviceTypes;

        vm.$nextTick(() => {
          vm.fullLoaded = true;
        });
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API
            .services()
            .edit(Number(this.$route.params.id), this.model);
          await this.$router.push("/services");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global_alert.successful_edit")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    addRow(): void {
      this.model.values.push({});
    },
    removeRow(index: number): void {
      this.model.values.splice(index, 1);
    }
  }
});
